export default __webpack_public_path__ + "static/media/040_tunnel.first.81fe6580.webp";